import * as Yup from 'yup';
import { Role } from '../types';


export const InviteUserSchema = Yup.object().shape({
    email: Yup.string().email("Please enter a valid email address").required("Email Address is required"),
    role_name: Yup.mixed().oneOf(Object.values(Role), 'Invalid Role').required('User role is required'),
});

